import { useEffect, useState } from "react"

// Tracks whether the viewport is below `breakpoint` and stays in sync on
// resize/orientation change. Replaces the `useRef(window.innerWidth)` pattern
// that captured once on mount and left the UI stuck on the initial layout.
export default function useViewportMinimized(breakpoint = 1080) {
  const [isMinimized, setIsMinimized] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  )

  useEffect(() => {
    if (typeof window === "undefined") return
    const onResize = () => setIsMinimized(window.innerWidth < breakpoint)
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [breakpoint])

  return isMinimized
}
